import React from 'react';

import { useLocation } from '@reach/router';
import { Helmet } from 'react-helmet';

import { env } from '../utils/env';

export default function HeadAddons() {
  const location = useLocation();

  const relCanonical =
    location.pathname !== env.PUBLIC_URL &&
    location.pathname !== `${env.PUBLIC_URL}/` ? (
      <link rel="canonical" href={`https://go4robot.pl${env.PUBLIC_URL}`} />
    ) : null;

  const robotsNoIndex =
    location.pathname !== env.PUBLIC_URL &&
    location.pathname !== `${env.PUBLIC_URL}/` ? (
      <meta name="robots" content="noindex" />
    ) : null;

  return (
    <Helmet>
      {relCanonical}
      {robotsNoIndex}
    </Helmet>
  );
}
